import moment from 'moment';

function Ctrl($scope, $state, $stateParams, imgix, modalService) {
  console.log('$scope.list', $scope.list);

  $scope.modified = function(item) {
    if (!item || !item.modified) return false;

    const modified = moment(item.modified);

    return moment().diff(modified, 'hours') < 48;
  };

  $scope.goToItem = function(item) {
    if ($scope.isPreview) {
      return modalService.getMembership();
    }

    if (item.type === 'EVENT') {
      $state.go('app.event', {
        seoPathname: item.contentSeoPathname || (item.event && item.event.id ? item.event.id : item.event),
        back: $stateParams.id,
        backName: $scope.list ? $scope.list.title : null
      });
    }

    if (item.type === 'VENUE') {
      $state.go('app.venue', {
        seoPathname: item.contentSeoPathname || (item.venue && item.venue.id ? item.venue.id : item.venue),
        back: $stateParams.id,
        backName: $scope.list ? $scope.list.title : null
      });
    }

    return null;
  };

  $scope.imgix = function(src) {
    const options = {
      width: 500,
      height: 270
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'jsSdk.imgix',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/curatedListItemCard/controller.js